<template>
  <div class="stories">
    <div ref="sliderEl" class="stories-slider" data-uno-dos-trends-uuid="30183e47-d5ee-4bc7-8d74-6d35341fbe1c"></div>
    <div v-if="!storiesLoaded" class="stories-container__fake">
      <div class="stories-item-border"><div class="stories-item"></div></div>
      <div class="stories-item-border"><div class="stories-item"></div></div>
      <div class="stories-item-border"><div class="stories-item"></div></div>
      <div class="stories-item-border"><div class="stories-item"></div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "stories",
  data() {
    return {
      timerId: null,
      storiesLoaded: false,
    };
  },
  mounted() {
    this.pollStoriesReady();
  },
  methods: {
    pollStoriesReady() {
      this.timerId = setInterval(() => {
        if (this.$refs.sliderEl.childNodes.length) {
          clearInterval(this.timerId);
          this.storiesLoaded = true;
          fakeWindow.dispatchEvent(new Event("resize"));
        }
      }, 100);
    },
  },
};
</script>

<style lang="scss">
  .stories {
    &-slider {
      margin-top: -1px;
    }

    &-item {
      border-radius: 50%;
      background: linear-gradient(#F1F2F3, #DCDDDF);
      width: 56px;
      height: 56px;

      @media (max-width: 450px) {
        width: 66px;
        height: 66px;
      }

      &-border {
        border: 1px solid #DEDFE0;
        padding: 4px;
        width: 76px;
        height: 76px;
        border-radius: 50%;
        margin-right: 10px;

        @media (max-width: 450px) {
          width: 66px;
          height: 66px;
        }
      }
    }

    &-container {
      &__fake {
        display: flex;
        max-width: 1176px;
        margin: 16px auto;
        margin-top: 0px;

        .stories-item {
          width: 66px;
          height: 66px;

          @media (max-width: 450px) {
            width: 56px;
            height: 56px;
          }
        }

        @media (max-width: 450px) {
          justify-content: center;
        }

        @media (min-width: 943px) {
          display: none;
        }
      }

      .uno-dos-story>.uno-dos-story__slider {
        justify-content: left;

        @media (max-width: 450px) {
          justify-content: center;
        }

        &.more-stories {
          position: relative;

          &::after {
            content: '';
            width: 100%;
            position: absolute;
            z-index: 10;
            height: 100%;
            background: linear-gradient(to right, transparent 80%, white);
          }
        }
      }

      .uno-dos-story {
        &__img {
          width: 66px;
          height: 66px;
        }

        @media (max-width: 450px) {
          &__img {
            width: 56px;
            height: 56px;
          }
        }

        &__slider {
          &_title {
            padding-bottom: 20px;
          }
        }
        &__slide {
          height: 76px;
          flex: 0 0 76px;

          @media (max-width: 450px) {
            height: 66px;
            flex: 0 0 66px;
          }

          &_title {
            margin-bottom: 0;
          }

          &-title {
            font-size: 11px;
            font-weight: 600;
            line-height: 13px;
          }

          &:not(:last-child) {
            margin-right: 10px;

            @media (max-width: 450px) {
              margin-right: 6px;
            }
          }
        }
      }
    }
  }

  .uno-dos {
    &-arrow {
      display: none;
    }

    &-close {
      border: 0px;
      background: transparent;
      width: 16px;
      height: 16px;
      backdrop-filter: none;

      &:hover {
        background: transparent;
      }
    }

    &-watermark__container {
      display: none;
    }

    &-feed {
      &_active {
        padding-top: 0px;
      }

      &_landscape {
        .uno-dos-feed__content {
          width: 100%;
        }

        .uno-dos-feed-bottom__text {
          color: #FFFFFF;
          font-weight: 700;
          font-size: 16px;
        }

        .uno-dos-feed-bottom__content {
          background: transparent;
          margin: 0 auto;
          padding: 0 14px;
          position: inherit;
        }

        @media (min-width: 960px) {
          .uno-dos-close svg {
            color: #FFFFFF;
          }

          .uno-dos-feed-btn {
            font-size: 16px;
            font-weight: 600;
          }
        }
      }

      @media (max-width: 450px) {
        &__content {
          border-radius: 0;
        }
      }
    }

    &-story {
      &__video {
        video {
          pointer-events: none;
        }
      }
    }
  }
</style>
